import dayjs from 'dayjs';
import { cn } from '@helpers/className';
import { TickIcon } from '@resortpass/solar-icons';
import React from 'react';

export function FreeCancellationTextFromDate({
  dateString,
  className,
}: {
  dateString: string;
  className?: string;
}) {
  return (
    <p className={cn('flex items-center justify-start', className)}>
      <span className="p-0.5">
        <TickIcon />
      </span>
      <span>
        Free cancellation before&nbsp;
        <b className="font-rp-pn-semi-bold">{dayjs(dateString).format('MMM D, hh:mma')}</b>
        &nbsp;property local time
      </span>
    </p>
  );
}

export function FreeCancellationText() {
  return (
    <span className="flex items-center">
      Free Cancellation
      <span className="m-0.5 text-solar-secondary">
        <TickIcon />
      </span>
    </span>
  );
}
